/* eslint-disable */
import type { ResponseContext } from "./ResponseContextProto.pb";
import type { ScenarioPlan } from "./scenarios.pb";
import type { StatusResult } from "./status_result.pb";

export interface SetDepositPreferenceResponse {
  response_context?: ResponseContext;
  /**
   * ScenarioPlan contains info about additional screens/blockers to complete the scenario.
   * There can still be blockers even if the status is SUCCESS. True SUCCESS is when status is
   * SUCCESS and there are no blockers.
   */
  scenario_plan?: ScenarioPlan;
  status?: SetDepositPreferenceResponseStatus;
  /**
   * Deprecated in v2.18 in favor of ResponseContext.
   *
   * @deprecated
   */
  status_result?: StatusResult;
}

/** If there are blockers, status will be SUCCESS with blockers on. */
export enum SetDepositPreferenceResponseStatus {
  INVALID = "INVALID",
  SUCCESS = "SUCCESS",
}
